<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: sun
 * @Date: 2022-03-14 23:12:24
-->
<template>
  <div class="home-container container">
    <!-- 顶部 -->
    <header>
      <!-- <img src="@/assets/imgs/head.png" /> -->
    </header>
    <!-- 中间 -->
    <main class="index-main main">
      <!-- esg报道 -->
      <section class="news list">
        <div class="list-title">
          <div class="title-left">{{ $route.query.name }}</div>
          <!-- <div class="title-right" v-if="guanchaData.length >= 3">
            <router-link :to="{ path: '/news' }">
              查看更多 <img src="@/assets/imgs/more-icon.png" />
            </router-link>
          </div> -->
        </div>
        <ul>
          <li v-for="(item, index) in baodaoData" :key="index">
            <a :href="item.article_url">
              <div class="item-left">
                <img :src="item.thumbnail_url" />
                <div
                  class="title-play"
                  v-if="$route.query.name.match('课堂')"
                ></div>
              </div>
              <div class="item-right">
                <p class="new-title">
                  {{ item.title }}
                </p>
                <p class="new-date">{{ item.created_at_str }}</p>
              </div>
            </a>
          </li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baodaoData: [],
    };
  },

  watch: {
    $route(to, from) {
      const that = this;
      that.$http
        .get(
          'http://www.nbd.com.cn/columns/' +
            this.$route.query.id +
            '/articles_list.json?simple_info=1'
        )
        .then(function(res) {
          console.log(res.data);
          that.baodaoData = res.data;
        });
    },
  },
  methods: {},
  mounted() {
    const that = this;
    that.$http
      .get(
        'http://www.nbd.com.cn/columns/' +
          this.$route.query.id +
          '/articles_list.json?simple_info=1'
      )
      .then(function(res) {
        console.log(res.data);
        that.baodaoData = res.data;
      });
  },
  methods: {
    handClick() {
      alert('敬请期待！');
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  a {
    display: flex;
    .item-left {
      position: relative;
      .title-play {
        width: 60px;
        height: 60px;
        position: absolute;
        left: 65px;
        bottom: 54px;
        background-image: url(http://static.nbd.com.cn/images/column_video/icon_play.png);
        background-size: 60px;
        background-position: center;
      }
      img {
        width: 200px;
        height: 150px;
        border-radius: 6px;
      }
    }
    .item-right {
      margin-left: 20px;
    }
  }
}
.container {
  overflow: hidden;
  .main {
    width: 1200px;
    margin: 0 auto;
    .list {
      overflow: hidden;
      margin-bottom: 30px;
      background: #f1f5f3;
      .list-title {
        background: #f8fbfa;
        // background: url(https://nbd-luyan-1252627319.cos.ap-shanghai.myqcloud.com/nbd-console/c9aec92ab415b28796c2b8e777b890c8.png)
        // no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: space-between;
        font-size: 20px;
        padding: 16px 0;
        font-weight: bold;
        align-items: center;
        a {
          color: #3c906c;
          vertical-align: middle;
          font-size: 14px;
        }
      }
      ul {
        background: #f1f5f3;
        padding: 16px 37px;
        li {
          overflow: hidden;
          margin: 20px 0;
          a {
            color: #333;
            text-decoration: none;
            font-size: 18px;
            text-shadow: 0 0 0;
            display: flex;
            .new-date {
              color: #333;
              font-size: 18px;
            }
          }
        }
      }
    }
    .item {
      .item-title {
        margin: 60px 0 20px;
        color: #303133;
        font-size: 22px;
      }
    }
    .xingdongpai-item {
      cursor: pointer;
      .tags-box {
        background: #2b926a;
        margin-top: -0.5rem;
        margin-bottom: 0.5rem;
        padding: 0 0.3rem;
        overflow: hidden;
        border-bottom-left-radius: 0.2rem;
        border-bottom-right-radius: 0.2rem;
        h1 {
          color: #aaefab;
          font-size: 0.34rem;
          margin: 0.3rem 0 0.2rem 0.3rem;
        }
        .tags {
          display: flex;
          flex-flow: row wrap;
          a {
            color: #fff;
            text-decoration: none;
            font-size: 0.26rem;
            background: #3d9d79;
            display: inline-block;
            padding: 0.1rem 0.2rem;
            margin: 0.2rem 0.1rem;
            border-radius: 0.5rem;
          }
        }
      }
      form {
        border: 1px solid #a5e7b7;
        height: 88px;
        line-height: 88px;
        border-radius: 0.2rem;
        outline: none;
        display: flex;
        overflow: hidden;
        background: #fff;
        align-items: center;
        margin-bottom: 0.5rem;
        .searchBtn {
          width: 30px;
          margin: 0 25px;
        }
        input {
          height: 80%;
          width: 100%;
          font-size: 30px;
          color: #333;
          border: 0;
          outline: none;
          &::-webkit-input-placeholder {
            color: #a5e7b7;
          }
        }
      }
    }
  }
  header {
    img {
      display: block;
      width: 1200px;
      margin: 0 auto;
      cursor: pointer;
    }
  }
}
</style>
